import wrapWithIntercom from 'components/common/utils/IntercomWrapper';
import loadAffCapture from 'utils/oms/loadAffCapture';
import Segment from 'utils/segment';
import { omsAppUrl } from 'utils/siteConfig';


const captureAffiliationParams = () => {
  if (window.affCapture) {
    window.affCapture(`${omsAppUrl}api/capture`);
  }
}

const onClientEntry = () => {
  captureAffiliationParams()
};

const onRouteUpdate = ({ location, prevLocation }) => {
  captureAffiliationParams();
  Segment.onRouteUpdate({ location, prevLocation })
};

const wrapRootElement = wrapWithIntercom;

const doNotDeleteThisMethod = () => {
  // Also do not try to call this method like that. Use window.affCapture.
  loadAffCapture() // to avoid eslint deleting unused import
}

export {
  onRouteUpdate,
  onClientEntry,
  wrapRootElement,
};

